import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pwc315Api, QueryParams, ReportItem, CurrencySummary } from '../../../services/pwc315Api';

export interface PWC315QueryState {
  loading: boolean;
  items: ReportItem[];
  currencySummary: CurrencySummary[];
  totalNtAmount: number;
  totalCount: number;
  queried: boolean;
  noData: boolean;
  runQuery: (params: QueryParams) => Promise<void>;
  reset: () => void;
}

export function usePWC315Query(): PWC315QueryState {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState<ReportItem[]>([]);
  const [currencySummary, setCurrencySummary] = useState<CurrencySummary[]>([]);
  const [totalNtAmount, setTotalNtAmount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const clearAll = useCallback(() => {
    setItems([]);
    setCurrencySummary([]);
    setTotalNtAmount(0);
    setTotalCount(0);
  }, []);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    clearAll();
    try {
      const resp = await pwc315Api.query(params);
      const data = resp.data;
      if (!data.items || data.items.length === 0) {
        setNoData(true);
        message.info(resp.message || '查無符合條件的交運單資料!');
      } else {
        setItems(data.items);
        setCurrencySummary(data.currency_summary || []);
        setTotalNtAmount(data.total_nt_amount || 0);
        setTotalCount(data.total_count || 0);
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, [clearAll]);

  const reset = useCallback(() => {
    clearAll();
    setQueried(false);
    setNoData(false);
  }, [clearAll]);

  return {
    loading, items, currencySummary, totalNtAmount, totalCount,
    queried, noData, runQuery, reset,
  };
}
